<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body ship-log-records-bd">
      <div class="content">
        <div class="wrap-aside">
          <div class="aside-title">
            {{ $t('crm_ship_logisticsRecords_dialog.wu_liu_dan_hao') }}：
            <span>{{model.data.shipmentNum}}</span>
          </div>
          <div class="flow">
            <ul>
              <li v-for="(item, index) in model.data.logList" :key="index">
                <div class="ub tit ub-xc">
                  <div class="dit1" :class="{ dit: index === 0 }">
                    <div></div>
                  </div>
                  <h1>{{ item.ftime }}</h1>
                </div>
                <div>
                  <p>{{ item.context }}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="oncancel">{{ $t('Common.com_close') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      logList: [],
    };
  },
  mounted() {},
  methods: {
    // 确认保存菜单
    oncancel: function () {
      this.visible = false;
    },
  },
};
</script>

<style lang="scss">
.ship-log-records-bd {
  .wrap-aside {
    width: 100%;
    background-color: #ffffff;
    padding-bottom: 10px;
    .aside-title {
      line-height: 40px;
      height: 40px;
      padding-left: 20px;
      color: #495057;
      font-weight: 500;
      font-size: 16px;
      border-bottom: 1px solid #eef2f8;
      margin-bottom: 10px;
      span{
        color: #000;
      }
    }
    .flow {
      padding: 25px 0 25px 32px;
      height: 560px;
      overflow-y: auto;
      .dit1.dit {
        background-color: #ffffff;
        padding: 5px;
        width: 20px;
        div {
          background-color: #4a90e2;
          width: 11px;
          height: 11px;
          border-radius: 7px;
          position: relative;
          &:after {
            content: '';
            position: absolute;
            left: 3px;
            top: 3px;
            z-index: 1;
            width: 5px;
            height: 5px;
            border-radius: 6px;
            background-color: #ffffff;
          }
        }
      }

      .dit1 {
        background-color: #ffffff;
        padding: 3px 6px;
        width: 20px;
        div {
          background-color: #8c8c8c;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          position: relative;
        }
      }
      ul > li {
        padding: 14px 20px 44px 23px;
        border-left: 1px solid #bfbfbf;
        position: relative;
        word-break: break-all;
        box-sizing: content-box;
        &:last-child {
          border-left: 1px solid #ffffff;
        }
        .tit {
          position: absolute;
          top: -12px;
          left: -11px;
        }
        h1 {
          color: #495057;
          font-size: 12px;
          line-height: 24px;
          margin-left: 14px;
          font-weight: 500;
        }
        p {
          font-size: 12px;
          color: #6c757d;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
